<template>
  <v-app>
    <div>
      <div class="page-container">
        <transition name="slide-fade" appear enter-active-class="animated flipInX" leave-active-class="animated fadeOutDown">
          <v-card color="white" width="300px">
            <v-card-title primary-title class="headline">
              Error 404
            </v-card-title>
            <v-card-text>
              <span class="subheading">Page not found.</span>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="green" @click="$router.go(-1)">
                <v-icon>keyboard_arrow_left</v-icon>
                Go back
              </v-btn>
            </v-card-actions>
          </v-card>
        </transition>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'Error404',
  data () {
    return {
      randomImageIndex: 66
    }
  },
  methods: {
    backPage () {
      this.$router.go(-1)
    },
    goHome () {
      this.$router.push({
        name: 'Home'
      })
    }
  },
  computed: {
  }
}
</script>

<style scoped>
#back_button {
  position: absolute;
}
.page-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.2) 100%), url('https://picsum.photos/id/901/1920/1080');
  background-size: cover;
  background-position: center;
}
</style>
